import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLines } from "@/components/motion";

export default function PageHero({ title, subtitle, image, crumbs = [] }) {
  const words = (title || "").split(" ");
  const lines = words.length > 3
    ? [words.slice(0, Math.ceil(words.length / 2)).join(" "), words.slice(Math.ceil(words.length / 2)).join(" ")]
    : [title];

  return (
    <section data-testid="page-hero" className="relative pt-[74px] bg-[#2d1616] text-white overflow-hidden">
      <div className="relative h-[46vh] min-h-[360px] max-h-[520px]">
        {image && <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#2d1616] via-[#2d1616]/50 to-[#2d1616]/40" />
        <div className="absolute inset-0 paper-grain opacity-20" />
        <div className="relative h-full max-w-[1400px] mx-auto px-5 sm:px-8 flex flex-col justify-end pb-12">
          <nav className="flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-white/70 mb-5">
            <Link to="/" className="hover:text-[#e8c970]">Home</Link>
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-2">
                <ChevronRight className="w-3 h-3" />
                {c.to ? <Link to={c.to} className="hover:text-[#e8c970]">{c.label}</Link> : <span className="text-[#e8c970]">{c.label}</span>}
              </span>
            ))}
          </nav>
          <h1 className="font-serif text-4xl sm:text-6xl lg:text-7xl leading-[1.0] tracking-tight">
            <MaskedLines lines={lines} />
          </h1>
          {subtitle && (
            <motion.p initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }} className="mt-5 max-w-2xl text-white/80 text-base sm:text-lg leading-relaxed">
              {subtitle}
            </motion.p>
          )}
        </div>
      </div>
    </section>
  );
}
